import React from 'react'

const ReceivedProductsTOSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4479_47352)" />
    <g clipPath="url(#clip0_4479_47352)">
      <path
        d="M26.9869 29.4297C26.9869 29.4948 26.9869 29.6251 26.9869 29.6903C26.9869 32.8173 26.9869 35.9443 26.9869 39.1365C26.9869 40.1789 27.8338 41.0258 28.8762 41.0258C32.9804 41.0258 37.0195 41.0258 41.1237 41.0258C42.2312 41.0258 43.013 40.3092 43.013 39.1365C43.013 36.0095 43.013 32.8825 43.013 29.6903C43.013 29.6251 43.013 29.56 43.013 29.4297C37.671 29.4297 32.329 29.4297 26.9869 29.4297ZM38.5179 33.8597C38.5179 34.3157 38.127 34.7066 37.671 34.7066H32.329C31.8729 34.7066 31.4821 34.3157 31.4821 33.8597C31.4821 33.4036 31.8729 33.0127 32.329 33.0127H37.671C38.127 33.0127 38.5179 33.4036 38.5179 33.8597Z"
        fill="white"
      />
      <path
        d="M42.8827 28.5179H27.1172C26.5961 28.5179 26.14 28.0619 26.14 27.5407V25.9772C26.14 25.456 26.5961 25 27.1172 25H42.8827C43.4039 25 43.8599 25.456 43.8599 25.9772V27.4756C43.8599 28.0619 43.4039 28.5179 42.8827 28.5179Z"
        fill="white"
      />
      <path
        d="M50.9609 45.0004H19.0391C18.3225 45.0004 17.7361 44.4141 17.7361 43.6975C17.7361 42.9809 18.3225 42.3945 19.0391 42.3945H50.9609C51.6775 42.3945 52.2638 42.9809 52.2638 43.6975C52.2638 44.4141 51.6775 45.0004 50.9609 45.0004Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M51.9381 25H47.8339C47.3127 25 46.8567 25.456 46.8567 25.9772V27.4756C46.8567 27.9967 47.3127 28.4528 47.8339 28.4528H51.9381V25Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M51.9381 29.4297C50.5049 29.4297 49.1368 29.4297 47.7036 29.4297C47.7036 29.4948 47.7036 29.6251 47.7036 29.6903C47.7036 32.8173 47.7036 35.9443 47.7036 39.1365C47.7036 40.1789 48.5505 41.0258 49.5928 41.0258C50.3746 41.0258 51.1564 41.0258 51.9381 41.0258V29.4297Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M18.0619 25H22.1661C22.6873 25 23.1433 25.456 23.1433 25.9772V27.4756C23.1433 27.9967 22.6873 28.4528 22.1661 28.4528H18.0619V25Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M18.0619 29.4297C19.4951 29.4297 20.8632 29.4297 22.2964 29.4297C22.2964 29.56 22.2964 29.6251 22.2964 29.6903C22.2964 32.8173 22.2964 35.9443 22.2964 39.1365C22.2964 40.1789 21.4495 41.0258 20.4072 41.0258C19.6254 41.0258 18.8436 41.0258 18.0619 41.0258V29.4297Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4479_47352"
        x1="-1.56654e-06"
        y1="4.96155"
        x2="70"
        y2="66.9615"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5A100" />
        <stop offset="1" stopColor="#F14B12" />
      </linearGradient>
      <clipPath id="clip0_4479_47352">
        <rect width="34.5277" height="20" fill="white" transform="translate(17.7361 25)" />
      </clipPath>
    </defs>
  </svg>
)

export default ReceivedProductsTOSubcategory
